// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.

export { EmbedConstants as AppStreamEmbedConstant } from "./ReadOnlyAppStreamEmbed";

export enum ERROR_STATE {
  NONE = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

// WorkSpacesWeb SDK
export const WORKSPACES_WEB = {
  DEBUG: true,
  LANDING_PAGE:
    "http://demo.cloudbrowse.a2z.com.s3-website-us-west-2.amazonaws.com/",
  PRODUCT_NAME: "ermine",
  REGION: "us-west-2",
  // Local Test: Use the default value or change this to your own stage
  STAGE: "beta",
};

export const CONFIG_ELEMENTS = {
  ENV_INFO: "env-info",
  CUSTOMER_CONFIG: "customer-config",
};

export const TEST_USER_AGENT_SUFFIX = "LowAngleTest";

export const NIVA_USER_AGENT_ID = "AFTGAZLTC";

export const URL_PARAMETER = {
  LEGACY: "legacy",
};
